import { DRAFT_CREATE_ACTION } from '../Draft.constants'

export function getDraftCreateActionSelectModalOptions({
  createNewLabelKey,
  openDraftLabelKey,
  t,
}) {
  return [
    {
      id: DRAFT_CREATE_ACTION.createNew,
      label: t(createNewLabelKey),
    },
    {
      id: DRAFT_CREATE_ACTION.openDraft,
      label: t(openDraftLabelKey),
    },
  ]
}
